import { omit } from '../array/omit'

export function fromParam(url?: string): Record<string, any> {
  // {min:100,max:200} <- ?min=100&max=200
  const documentSearch =
    typeof document === 'undefined' ? '' : document.location.search
  let str
  if (url) {
    const split = url.split('/')
    str = split[split.length - 1]
  }

  if (!str && !documentSearch) {
    return {}
  }

  const urlString = (str || documentSearch).replace(/(^\?)/, '')

  if (!urlString || urlString.trim() === '') {
    return {}
  }

  try {
    const params = new URLSearchParams(urlString)
    const result: Record<string, any> = {}
    for (const [key, value] of params.entries()) {
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        if (!Array.isArray(result[key])) {
          result[key] = [result[key]]
        }
        result[key].push(value)
      } else {
        result[key] = value
      }
    }
    return result
  } catch (e) {
    return {}
  }
}

export function toParam(
  obj?: Record<string, any>,
  options?: { arrayFormat?: 'comma' | 'repeat' },
): string {
  // {min:100,max:200} -> ?min=100&max=200
  // Arrays: 'repeat' (default): {ids: ['A','B']} -> ids=A&ids=B
  //         'comma':            {ids: ['A','B']} -> ids=A,B
  if (!obj) return ''
  const arrayFormat = options?.arrayFormat || 'repeat'
  const allDefined = omit(
    obj,
    Object.keys(obj).filter(
      (key) =>
        typeof obj[key] === 'undefined' ||
        obj[key] === null ||
        (Array.isArray(obj[key]) && obj[key].length === 0),
    ),
  )
  const params: string[] = []

  Object.keys(allDefined).forEach((k) => {
    const val = allDefined[k]
    if (Array.isArray(val)) {
      if (arrayFormat === 'repeat') {
        val.forEach((item) => {
          params.push(`${encodeURIComponent(k)}=${encodeURIComponent(item)}`)
        })
      } else {
        params.push(
          `${encodeURIComponent(k)}=${encodeURIComponent(val.join(','))}`,
        )
      }
    } else {
      params.push(`${encodeURIComponent(k)}=${encodeURIComponent(val)}`)
    }
  })

  return params.join('&')
}
